const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;
const IMAGE_BASE_URL = import.meta.env.VITE_IMAGE_BASE_URL;
const RESTAURANT_ID = 16;
const DELIVERY_FEE = 0;
const OPEN_TIMING = "8:00";
const OPEN_TIME = "12:00";
const CLOSE_TIME = "8:00";
const CART_STORAGE_KEY = "pixwipizza_cart_items";
const CART_EXPIRY_KEY = "pixwipizza_cart_expiry";
const CART_EXPIRY_HOURS = 3;

interface ApiConfig {
  BASE_URL: string;
  IMAGE_BASE_URL: string;
  RESTAURANT_ID: number;
  DELIVERY_FEE: number;
  OPEN_TIMING: string;
  OPEN_TIME: string;
  CLOSE_TIME: string;
  CART_STORAGE_KEY: string;
  CART_EXPIRY_KEY: string;
  CART_EXPIRY_HOURS: number;
}

const apiConfig: ApiConfig = {
  BASE_URL: API_BASE_URL,
  IMAGE_BASE_URL: IMAGE_BASE_URL,
  RESTAURANT_ID: RESTAURANT_ID,
  DELIVERY_FEE: DELIVERY_FEE,
  OPEN_TIMING: OPEN_TIMING,
  OPEN_TIME: OPEN_TIME,
  CLOSE_TIME: CLOSE_TIME,
  CART_STORAGE_KEY: CART_STORAGE_KEY,
  CART_EXPIRY_KEY: CART_EXPIRY_KEY,
  CART_EXPIRY_HOURS: CART_EXPIRY_HOURS,
};

export default apiConfig;
